import { render, staticRenderFns } from "./Distribute.vue?vue&type=template&id=162f5b50&scoped=true&"
import script from "./Distribute.vue?vue&type=script&lang=js&"
export * from "./Distribute.vue?vue&type=script&lang=js&"
import style0 from "./Distribute.vue?vue&type=style&index=0&id=162f5b50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162f5b50",
  null
  
)

export default component.exports